import { createAsyncIcon } from '../_factory/createAsyncIcon';

const AsyncLucideIcon = createAsyncIcon(() => import('./LucideIcon'));

export default AsyncLucideIcon;

AsyncLucideIcon.displayName = 'AsyncLucideIcon';
